import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export function apimInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  if (req.url.includes(environment.apiConfig.baseUrlBackend)) {
    const newReq = req.clone({
      headers: req.headers.append(
        'Ocp-Apim-Subscription-Key',
        environment.apiConfig.subscriptionKeyBackend,
      ),
    });
    return next(newReq);
  }

  const newReq = req.clone({
    headers: req.headers.append(
      'Ocp-Apim-Subscription-Key',
      environment.apiConfig.subscriptionKeyAgent,
    ),
  });
  return next(newReq);
}
